import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Elements, StripeProvider } from 'react-stripe-elements';
import CheckoutForm from './CheckOutForm';
import { SlideDown } from 'react-slidedown'
//import FormControlLabel from '@material-ui/core/FormControlLabel';
import { PrimaryButton } from '@fluentui/react';
//import Checkbox from '@material-ui/core/Checkbox';
import { AUTH_CONFIG } from '../../Auth/auth0-variables';
import Loading from '../Loading';
import axios from 'axios';

// Lazy-load Stripe.js v3 on demand (no longer eagerly loaded from index.html).
// Returns a promise that resolves once window.Stripe is available.
let stripeJsPromise = null;
function loadStripeJs() {
    if (typeof window === 'undefined') return Promise.resolve();
    if (window.Stripe) return Promise.resolve();
    if (stripeJsPromise) return stripeJsPromise;
    stripeJsPromise = new Promise((resolve, reject) => {
        const existing = document.querySelector('#stripe-js');
        if (existing) {
            existing.addEventListener('load', resolve);
            existing.addEventListener('error', reject);
            return;
        }
        const s = document.createElement('script');
        s.id = 'stripe-js';
        s.src = 'https://js.stripe.com/v3/';
        s.async = true;
        s.onload = resolve;
        s.onerror = reject;
        document.head.appendChild(s);
    });
    return stripeJsPromise;
}

export class CheckOut extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            subStatus: undefined,
            stripe: null,
            closed: true,
            facilities: [],
            type: 'annually',
            isFetching:true
        };
        this.updateSub = this.updateSub.bind(this);
        this.toggleFac = this.toggleFac.bind(this)
    }

    updateSub(x) {
        this.setState({ type: x });
    }

    toggleFac(e) {
        e.preventDefault()
        this.setState({ closed: !this.state.closed });
    }

    componentDidMount() {
        loadStripeJs().then(() => {
            if (window.Stripe) {
                this.setState({ stripe: window.Stripe('pk_test_C86R4UBQqdW7R46z09mwOKt8') });
            }
        });
        
        const items = [];
        this.props.facilities.forEach((element, index) => {
            
            axios.get(AUTH_CONFIG.API_URL + "/api/Stripe/CheckSubscription?facilityId=" + element.facilityID + "&ProductSlug=" + this.props.product)
                .then((response) => {
                    
                    if (response.data.status != "active") {
                        const item = { facility: element.name, facilityId: element.facilityID, checked: true, status: response.data.status };
                        items.push(item);
                        this.setState({
                            facilities: items,
                            isFetching: false
                        });
                    }
                    else {
                        this.setState({
                            isFetching: false
                        });
                    }
                    
                });
        });
        
    }

    handleFaChange = (e, i) => {
        this.state.facilities[i].checked = e.target.checked;
        this.setState({
            facilities: this.state.facilities
        });
    };

    render() {
        if (this.state.isFetching) {
            return <Loading style={{ position: 'relative', backgroundColor: 'transparent' }} />
        }
        return (
            <div>
                <div className="displayflex">
                    <div className={`card box price-wrap ${this.state.type == 'monthly' ? 'active' : ''}`} onClick={e => this.setState({ type:'monthly'})}>

                        <div className="card-block p-b-10">
                            <h5 className=" text-dark-to-light" style={{ margin: '10px 0 5px' }}>
                                Monthly
                        </h5>
                            <div className="pricing_plan--price">
                                <span class="pricing text-dark-to-light">
                                    <sup class="dollar_sign text-dark-to-light">$</sup>
                                    99
                            </span>
                            </div>
                            <div className="pricing_plan--term">Per month / Billed monthly</div>

                            <PrimaryButton
                                text={'Get started'}
                                className="mt20"
                                style={{ backgroundColor: 'rgb(48 144 239)', height: 38 }}
                                onClick={e => {
                                    window.location = AUTH_CONFIG.API_URL + "/api/stripe/create-checkout-session?clientId=" + this.props.clientId + "&slug=all-products-monthly"
                                }}
                            />
                        </div>
                    </div>
                    <div className={`card box price-wrap m-l-30 ${this.state.type == 'annually' ? 'active' : ''}`} style={{ 'marginLeft': '30px' }} onClick={e => this.setState({ type: 'annually' })}>

                        <div className="card-block p-b-10">
                            <h5 className=" text-dark-to-light" style={{ margin: '10px 0 5px' }}>
                                Annually
                            </h5>
                            <div className="pricing_plan--price">
                                <span class="pricing text-dark-to-light">
                                    <sup class="dollar_sign text-dark-to-light">$</sup>
                                    1,069
                            </span>
                            </div>
                            <div class="pricing_plan--term">BILLED ANNUALLY</div>
                            <div class="pricing_plan--save" style={{ 'marginTop': '-15px' }}>Save 10% with Annual</div>
                            <PrimaryButton
                                text={'Get started'}
                                style={{ backgroundColor: 'rgb(48 144 239)', height: 38 }}
                                onClick={e => {
                                    window.location = AUTH_CONFIG.API_URL + "/api/stripe/create-checkout-session?clientId=" + this.props.clientId + "&slug=all-products-annually"
                                }}
                            />
                        </div>
                    </div>

                </div>
                <p style={{
                    margin: '30px 0px 20px',  display: 'inline-block', width: '100%', textAlign:'center'
                }}>All plans are priced per location.</p>
              
                {/*<div className="row"> */}
                {/*    <div class="col-md-12">*/}
                {/*        <div className="checkout-summary">*/}
                {/*            <h4 class="billing-order-summary__title">Order summary</h4>*/}
                {/*            <div class="separator"></div>*/}

                {/*            {this.state.type == 'annually' &&*/}
                {/*                <div class="billing-order-summary__checkout-list list-group">*/}
                {/*                    <li class="billing-order-summary-item">*/}
                {/*                        <i class="material-icons">done</i>Standard (with annual discount)<strong>$89.10/mo</strong>*/}
                {/*                    </li>*/}
                {/*                    <li class="billing-order-summary-item">*/}
                {/*                    <i class="material-icons">done</i>Annual subscription<strong>x 12</strong>*/}
                {/*                </li>*/}
                {/*                {this.state.facilities.filter(function (x) { return x.checked == true }).length > 1 && */}
                {/*                    <li class="billing-order-summary-item" style={{ marginBottom: '20px' }}>*/}
                {/*                        <span style={{ marginLeft: '40px' }}>Facilities</span><strong>x {this.state.facilities.filter(function (x) { return x.checked == true }).length}</strong><a style={{ float: 'right', marginRight: '10px ' }} href="" onClick={(e) => this.toggleFac(e)}>change</a>*/}
                {/*                    </li>*/}
                                   
                {/*                }*/}
                {/*                <SlideDown closed={this.state.closed}>*/}
                {/*                    <div class="separator"></div>*/}
                {/*                    <div style={{ paddingLeft: '40px' }}>*/}
                {/*                        */}{/*{this.state.facilities.map((f, index) => (*/}
                {/*                        */}{/*    <FormControlLabel*/}
                {/*                        */}{/*        control={*/}
                {/*                        */}{/*            <Checkbox*/}
                {/*                        */}{/*                checked={f.checked}*/}
                {/*                        */}{/*                color="primary"*/}
                {/*                        */}{/*                onChange={e => this.handleFaChange(e, index)}*/}
                {/*                        */}{/*            />*/}
                {/*                        */}{/*        }*/}
                {/*                        */}{/*        label={f.facility}*/}
                {/*                        */}{/*    />*/}
                {/*                        */}{/*))}*/}
                {/*                    </div>*/}
                {/*                </SlideDown>*/}
                {/*                </div>*/}
                {/*            }*/}
                {/*            {this.state.type == 'monthly' &&*/}
                {/*                <div class="billing-order-summary__checkout-list list-group">*/}
                {/*                    <li class="billing-order-summary-item">*/}
                {/*                        <i class="material-icons">done</i>Standard<strong>$99.00/mo</strong>*/}
                {/*                    </li>*/}
                {/*                    <li class="billing-order-summary-item">*/}
                {/*                        <i class="material-icons">done</i>Monthly subscription<strong>x 1</strong>*/}
                {/*                </li>*/}
                {/*                {this.state.facilities.filter(function (x) { return x.checked == true }).length > 1 &&*/}
                {/*                    <li class="billing-order-summary-item" style={{ marginBottom: '20px' }}>*/}
                {/*                        <span style={{ marginLeft: '40px' }}>Facilities</span><strong>x {this.state.facilities.filter(function (x) { return x.checked == true }).length}</strong><a style={{ float: 'right', marginRight: '10px ' }} href="" onClick={(e) => this.toggleFac(e)}>change</a>*/}
                {/*                    </li>*/}
                {/*                }*/}
                {/*                <SlideDown closed={this.state.closed}>*/}
                {/*                    <div class="separator"></div>*/}
                {/*                    <div style={{ paddingLeft: '40px' }}>*/}
                {/*                    */}{/*{this.state.facilities.map((f, index) => (*/}
                {/*                    */}{/*    <FormControlLabel*/}
                {/*                    */}{/*        control={*/}
                {/*                    */}{/*            <Checkbox*/}
                {/*                    */}{/*                checked={f.checked}*/}
                {/*                    */}{/*                color="primary"*/}
                {/*                    */}{/*                onChange={e => this.handleFaChange(e, index)}*/}
                {/*                    */}{/*            />*/}
                {/*                    */}{/*        }*/}
                {/*                    */}{/*        label={f.facility}*/}
                {/*                    */}{/*    />*/}
                {/*                    */}{/*    ))}*/}
                {/*                    </div>*/}
                {/*                </SlideDown>*/}
                {/*                </div>*/}
                {/*            }*/}

                {/*            <div class="separator" style={{marginTop:'4px'}}></div>*/}
                {/*            <div class="billing-order-summary__total">Total:*/}
                {/*                {this.state.type == 'annually' &&*/}
                {/*                    <strong>${1069.00 * this.state.facilities.filter(function (x) { return x.checked == true }).length}</strong>*/}
                {/*                }*/}
                {/*                {this.state.type == 'monthly' &&*/}
                {/*                    <strong>${99.00 * this.state.facilities.filter(function (x) { return x.checked == true }).length}</strong>*/}
                {/*                }*/}
                {/*            </div>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}
                {/*<div className="row">*/}
                {/*    <div class="col-md-12" style={{ 'margin-bottom': '50px' }}>*/}
                {/*        <StripeProvider stripe={this.state.stripe}>*/}
                {/*            <Elements>*/}
                {/*                <CheckoutForm type={this.state.type} facilities={this.state.facilities} product={this.props.product} />*/}
                {/*            </Elements>*/}
                {/*        </StripeProvider>*/}
                {/*    </div>*/}
                {/*</div>*/}
                {/*<div className="displayflex aligncenter justifycenter mb50">*/}
                {/*    <a style={{ color: 'rgba(26, 26, 26, .5)', fontSize: 12, fontWeight: '400' }} href="https://stripe.com" target="_blank"><span className="displayflex aligncenter" >Powered by <svg className="ml5" focusable="false" width="33" height="15"><g fill-rule="evenodd"><path d="M32.956 7.925c0-2.313-1.12-4.138-3.261-4.138-2.15 0-3.451 1.825-3.451 4.12 0 2.719 1.535 4.092 3.74 4.092 1.075 0 1.888-.244 2.502-.587V9.605c-.614.307-1.319.497-2.213.497-.876 0-1.653-.307-1.753-1.373h4.418c0-.118.018-.588.018-.804zm-4.463-.859c0-1.02.624-1.445 1.193-1.445.55 0 1.138.424 1.138 1.445h-2.33zM22.756 3.787c-.885 0-1.454.415-1.77.704l-.118-.56H18.88v10.535l2.259-.48.009-2.556c.325.235.804.57 1.6.57 1.616 0 3.089-1.302 3.089-4.166-.01-2.62-1.5-4.047-3.08-4.047zm-.542 6.225c-.533 0-.85-.19-1.066-.425l-.009-3.352c.235-.262.56-.443 1.075-.443.822 0 1.391.922 1.391 2.105 0 1.211-.56 2.115-1.39 2.115zM18.04 2.766V.932l-2.268.479v1.843zM15.772 3.94h2.268v7.905h-2.268zM13.342 4.609l-.144-.669h-1.952v7.906h2.259V6.488c.533-.696 1.436-.57 1.716-.47V3.94c-.289-.108-1.346-.307-1.879.669zM8.825 1.98l-2.205.47-.009 7.236c0 1.337 1.003 2.322 2.34 2.322.741 0 1.283-.135 1.581-.298V9.876c-.289.117-1.716.533-1.716-.804V5.865h1.716V3.94H8.816l.009-1.96zM2.718 6.235c0-.352.289-.488.767-.488.687 0 1.554.208 2.241.578V4.202a5.958 5.958 0 0 0-2.24-.415c-1.835 0-3.054.957-3.054 2.557 0 2.493 3.433 2.096 3.433 3.17 0 .416-.361.552-.867.552-.75 0-1.708-.307-2.467-.723v2.15c.84.362 1.69.515 2.467.515 1.879 0 3.17-.93 3.17-2.548-.008-2.692-3.45-2.213-3.45-3.225z"></path></g></svg></span></a>*/}
                {/*</div>*/}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    facilityId: state.appState.product.facility.facilityID,
    facilities: state.appState.product.availableFacilities,
    clientId: state.appState.clientID,
});

export default connect(mapStateToProps)(CheckOut);



